import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'has_the_fac_engaged_in_any_of_these_actions_due_to_a_workers_tr'

export const dataPointDefinition = {
  retracedId: 'has_the_fac_engaged_in_any_of_these_actions_due_to_a_workers_tr',
  name: "Has the facility engaged in any of these actions due to a worker's trade union membership or activities?",
  description: 'Trade union activities also include attempts to create a union.',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'THREATENED_INTIMIDATED_OR_HARASSED',
      text: 'Threatened intimidated, or harassed',
      externalIds: [
        {
          id: 'foa-cb-4--7-1x',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PUNISHED',
      text: 'Punished',
      externalIds: [
        {
          id: 'foa-cb-4--7-2x',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'TERMINATED_WORKERS_OR_DID_NOT_RENEW_THEIR_CONTRACT',
      text: 'Terminated workers or did not renew their contract',
      externalIds: [
        {
          id: 'foa-cb-4--7-3x',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'foa-cb-4--7-5x',
          version: '1.5.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'THREATENED_INTIMIDATED_OR_HARASSED',
                'PUNISHED',
                'TERMINATED_WORKERS_OR_DID_NOT_RENEW_THEIR_CONTRACT',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wi-foa-36',
      version: '1.5.0',
      provider: 'slcp',
    },
  ],
  sortingId: 12230,
  sectionId: '2.2.8',
  impactArea: 'Freedom of Association and Collective Bargaining',
  impactAreaId: 'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
